import { render, staticRenderFns } from "./SideRightHonor.vue?vue&type=template&id=335d9c9e&scoped=true"
import script from "./SideRightHonor.vue?vue&type=script&lang=js"
export * from "./SideRightHonor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335d9c9e",
  null
  
)

export default component.exports